(function () {
  function initStickyBar() {
    const wrap = document.querySelector('.rh-pdp-wrap');
    if (!wrap) return;

    const sticky = wrap.querySelector('[data-rh-pdp-sticky]');
    const submit = wrap.querySelector('.rh-pdp__submit');
    const stickyBtn = wrap.querySelector('[data-rh-sticky-atc]');
    const form = wrap.querySelector('.rh-pdp__form');

    if (!sticky || !submit || !stickyBtn || !form) return;

    stickyBtn.addEventListener('click', () => {
      submit.click();
      window.scrollTo({ top: wrap.offsetTop, behavior: 'smooth' });
    });

    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.hidden = entry.isIntersecting;
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(submit);
  }

  function initAccordions() {
    document.querySelectorAll('.rh-pdp-accordion').forEach((item) => {
      item.addEventListener('toggle', () => {
        const icon = item.querySelector('.rh-pdp-accordion__icon');
        if (icon) icon.textContent = item.open ? '−' : '+';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initStickyBar();
      initAccordions();
    });
  } else {
    initStickyBar();
    initAccordions();
  }

  document.addEventListener('shopify:section:load', () => {
    initStickyBar();
    initAccordions();
  });

  function syncStickyPrice() {
    const wrap = document.querySelector('.rh-pdp-wrap');
    if (!wrap) return;
    const priceSource = wrap.querySelector('[id^="price-"]:not([id*="sticky"])');
    const stickyPrice = wrap.querySelector('[id^="price-sticky-"]');
    if (!priceSource || !stickyPrice) return;

    const observer = new MutationObserver(() => {
      const current = priceSource.querySelector('.price-item--sale, .price-item--regular');
      if (current) stickyPrice.textContent = current.textContent.trim();
    });

    observer.observe(priceSource, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStickyPrice);
  } else {
    syncStickyPrice();
  }
})();
